export default "__VITE_ASSET__Cof5v7OD__"